import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "main" }

import store from "@/store";
import chunk from "lodash-es/chunk";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  mobileHeader,
  footerMenu,
  mobileMenu,
  fullLoading,
} from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
  active?: boolean;
}

const headerHeight = "4rem";
const footerHeight = "4.5rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'panel',
  props: {
    accountId: {},
    tabActive: {},
    menuList: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v30fb6eaa": (headerHeight),
  "da5b8190": (footerHeight)
}))

const { t } = useI18n();

const props = __props;

const mobileMenuOpen = ref<string | null>(null);

const footerMenuList = computed(() => [
  ...chunk(props.menuList || [], 3)[0],
  {
    key: "menu",
    icon: "grid",
    label: t("common.labels.menu"),
  },
  // {
  //   key: "alert",
  //   icon: "alert",
  //   label: t("common.labels.alert"),
  // },
]);

function openFooterMenu(value: any) {
  mobileMenuOpen.value = value.key;
  console.log("openFooterMenu", value);
}

function menuMobileClose() {
  mobileMenuOpen.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(mobileHeader), { height: headerHeight }),
      _createElementVNode("main", _hoisted_3, [
        _renderSlot(_ctx.$slots, "main")
      ]),
      _createVNode(_unref(footerMenu), {
        "menu-list": footerMenuList.value,
        height: footerHeight,
        onOpen: openFooterMenu
      }, null, 8, ["menu-list"])
    ]),
    (_unref(store).getters.loading)
      ? (_openBlock(), _createBlock(_unref(fullLoading), { key: 0 }))
      : _createCommentVNode("", true),
    (mobileMenuOpen.value === 'menu')
      ? (_openBlock(), _createBlock(_unref(mobileMenu), {
          key: 1,
          "menu-list": __props.menuList,
          active: __props.tabActive,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (menuMobileClose()))
        }, null, 8, ["menu-list", "active"]))
      : _createCommentVNode("", true)
  ]))
}
}

})